import { MonotoneSvgProps } from './types';

export default function ScatterSVG({ primaryColor }: MonotoneSvgProps) {
  return (
    // <!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      xmlSpace="preserve"
    >
      <style type="text/css">
        {/* <!-- svg classes --> */}
        .dots&#123;fill-rule:evenodd;clip-rule:evenodd;stroke:#FFFFFF;stroke-width:4.0441;stroke-miterlimit:10;&#125;
      </style>
      <g style={{ fill: primaryColor }} className="primary-fill">
        <circle
          id="Dot_1_00000115504741058482569830000015073583175696001194_"
          className="dots"
          cx="99.587"
          cy="340.511"
          r="16.529"
        />
        <circle
          id="Dot_2_00000098901791366925116180000014398150639453591182_"
          className="dots"
          cx="66.529"
          cy="433.073"
          r="16.529"
        />
        <circle
          id="Dot_2_00000104686321419454830890000002629463743666826685_"
          className="dots"
          cx="173.859"
          cy="367.09"
          r="16.529"
        />
        <circle
          id="Dot_2_00000179603553782744289960000018103087445197078175_"
          className="dots"
          cx="116.116"
          cy="394.49"
          r="16.529"
        />
        <circle
          id="Dot_3_00000009558073371848154450000012675610816289580707_"
          className="dots"
          cx="244.806"
          cy="279.352"
          r="16.529"
        />
        <circle
          id="Dot_4_00000165946839095174043270000004065712216614242706_"
          className="dots"
          cx="244.806"
          cy="208.801"
          r="16.529"
        />
        <circle
          id="Dot_5_00000020371789801563559270000000171265476566915992_"
          className="dots"
          cx="328.618"
          cy="204.852"
          r="16.529"
        />
        <circle
          id="Dot_6_00000093142036493484749150000012188403557256843411_"
          className="dots"
          cx="394.797"
          cy="188.323"
          r="16.529"
        />
        <circle
          id="Dot_6_00000033328471889580810260000008522170949999805603_"
          className="dots"
          cx="433.471"
          cy="124.389"
          r="16.529"
        />
        <circle
          id="Dot_6_00000114051953610612971930000009203010549378757299_"
          className="dots"
          cx="378.268"
          cy="66.927"
          r="16.529"
        />
        <circle
          id="Dot_7_00000166635395855505043740000007442320305307380399_"
          className="dots"
          cx="261.335"
          cy="344.665"
          r="16.529"
        />
        <circle
          id="Dot_7_00000074437792603804286120000001671783379845279877_"
          className="dots"
          cx="342.771"
          cy="126.716"
          r="16.529"
        />
        <circle
          id="Dot_7_00000154404751714864821520000005428575868376238468_"
          className="dots"
          cx="371.763"
          cy="259.965"
          r="16.529"
        />
        <circle
          id="Dot_8_00000059283871613088987460000002728120315844247461_"
          className="dots"
          cx="162.3"
          cy="279.352"
          r="16.529"
        />
        <circle
          id="Dot_8_00000065786609662761586910000000233283446241232519_"
          className="dots"
          cx="303.989"
          cy="266.27"
          r="16.529"
        />
      </g>
    </svg>
  );
}
